import { render, staticRenderFns } from "./assetDepreciationParamDialog.vue?vue&type=template&id=2652931a&scoped=true"
import script from "./assetDepreciationParamDialog.vue?vue&type=script&lang=js"
export * from "./assetDepreciationParamDialog.vue?vue&type=script&lang=js"
import style0 from "./assetDepreciationParamDialog.vue?vue&type=style&index=0&id=2652931a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652931a",
  null
  
)

export default component.exports